import React, { useState } from 'react'
import { toDateAndMonthString, toLocalDateString } from 'utils'
import { TextFlagButtonsContainer, TextFlagState, ToolbarTextFlagButton } from 'view/components/buttons'
import { dynamicDates, filterEqualsDynamicDate } from '../utils'

interface DynamicDateSubscriptionButtonsProps {
  currentFilterDates: string[]
  disabled?: boolean
  onClick: (dates: string[]) => void
}

export const DynamicDateSubscriptionButtons: React.FC<DynamicDateSubscriptionButtonsProps> = ({
  onClick,
  currentFilterDates,
  disabled
}) => {
  const currentDynamicFilterDates = currentFilterDates.filter(currentFilterDate =>
    dynamicDates.some(dynamicDate => toLocalDateString(dynamicDate) === currentFilterDate)
  )
  const [selectedDates, setSelectedDates] = useState(currentDynamicFilterDates)

  const handleSelectDate = (date: string) => {
    const updatedSelectedDates = selectedDates.includes(date)
      ? selectedDates.filter(selectedDate => selectedDate !== date)
      : [...selectedDates, date]
    setSelectedDates(updatedSelectedDates)
    onClick(updatedSelectedDates)
  }

  return (
    <TextFlagButtonsContainer>
      {dynamicDates.map(date => {
        const label = toDateAndMonthString(date)
        const state = filterEqualsDynamicDate(currentFilterDates, date) && !disabled ? TextFlagState.On : TextFlagState.Off
        return (
          <ToolbarTextFlagButton
            dataTestId={'RollsDealsSubscriptionFilters-ToolbarTextFlagButton-ButtonFirstDay'}
            state={state}
            onClick={() => handleSelectDate(toLocalDateString(date))}
            key={label}>
            {label}
          </ToolbarTextFlagButton>
        )
      })}
    </TextFlagButtonsContainer>
  )
}
